const LOG_PREFIX = '[GET - Fetch Article By ID]';

export const fetchArticleFnKey = 'fetch-article-query-fn';

export default {
  LOG_PREFIX,
  fetchArticleFnKey,
};
